export class LoadingConfig {
  showSpinner: boolean;
  showErrors: boolean;
  ignoreUrls: string[];
}
